import ServiceIdentityList from './ServiceIdentityList';

export default ServiceIdentityList;
